import API from "@/api";

export default {
  methods: {
    async explanation(input, topic, focus_point) {
      return new Promise(async (resolve) => {
        let feedback = "";
        for (let x in input) {
          const res = await API.participantData.getSignificantPoint(input[x]);
          feedback = feedback.concat(
            res.emotion === "manual"
              ? `\n- Participant ${res.participant_id} gave feedback at a moment marked by the researcher: ${res.comment}`
              : `\n- Participant ${res.participant_id} experienced increased ${
                  res.emotion
                }. His/her feedback: ${res.comment}`
          );
        }
        let focus = null;
        if (focus_point) {
          focus = `Close your analysis of with an answer to the following research question: ${focus_point}.`;
        }

        let html_format =
          "Your response must be in HTML format. You can use tags like <p>, <b>, <u>, <i>, <a>, etc. Make sure to properly nest and format these tags.";
        // Send prompt request for summary
        let explanation_prompt = `You are a UX researcher and you are analyzing a list of feedback from several users on the topic ${topic} of a website. For each feedback it is mentioned what emotion the user experienced. Analyze the feedback and find the common key subjects the feedback is about. Then for each subject write how many participants this was related to, which emotions they mainly experienced, what their main feedback point was and why this happened, and paraphrase or quote one participant as an example. Make sure this quote is related to the most experienced emotion. If one of the participants provided suggestions for improvement on this subject than also add this to the subject. ${focus}  ${html_format} \n${feedback}`;
        let explanation_result = await API.openAi.prompt({
          prompt: explanation_prompt,
          max_tokens: 1000,
        });
        resolve(explanation_result);
      });
    },
    async summarizeInsight(input) {
      return new Promise(async (resolve) => {
        let summary_prompt = `Provide a short summary of maximum 100 words in the same language as the text of the following text: ${input}. Return this in HTML, and nothing else than your answer.`;
        let summary_result = await API.openAi.prompt({
          prompt: summary_prompt,
          max_tokens: 150,
        });
        resolve(summary_result);
      });
    },
    async generateSuggestions(input) {
      return new Promise(async (resolve) => {
        let suggestions_prompt = `Provide maximum of three suggestions with each a title of maximum five words, on how a website can be improved based on the following feedback of users. Provide the suggestions in the same language as the feedback. Return only an array in JSON format with a title and suggestion. ${input}.`;
        let suggestions_result = await API.openAi.prompt({
          prompt: suggestions_prompt,
          max_tokens: 500,
        });
        const suggestions = JSON.parse(suggestions_result);
        resolve(suggestions);
      });
    },
    async generateInsight() {
      this.isLoading = true;
      // Get all feedback
      let count = [
        { count: 0, emotion: "frustration" },
        { count: 0, emotion: "attention" },
        { count: 0, emotion: "joy" },
      ];
      let feedback = "";
      let emotion = "";

      for (let x in this.selectedTags) {
        const res = await API.participantData.getSignificantPoint(
          this.selectedTags[x]
        );
        if (res.emotion === "frustration") {
          count[0].count++;
        } else if (res.emotion === "attention") {
          count[1].count++;
        } else if (res.emotion === "joy") {
          count[2].count++;
        }
        feedback = feedback.concat(`\n- ${res.comment}`);
      }

      count.sort((a, b) =>
        a.count < b.count ? 1 : b.count < a.count ? -1 : 0
      );
      emotion.concat(count[0].emotion);

      // Send prompt request for summary
      let explanation_prompt = `Identificeer de belangrijkste onderwerpen die in onderstaande feedback worden gegeven. Geef, in HTML, per onderwerp een samenvatting van minimaal 400 woorden en verklaar de feedback waar mogelijk met een psychologische theorie. De feedback gaat over ${this.activeTag.name.toLowerCase()} op een website: \n${feedback}`;

      let explanation_result = await API.openAi.prompt({
        prompt: explanation_prompt,
        max_tokens: 2000,
      });

      // Send prompt request for title.
      let title_prompt = `Geef een beknopte omschrijving van de volgende feedback in maximaal 15 woorden: ${feedback}`;
      let title_result = await API.openAi.prompt({
        prompt: title_prompt,
        max_tokens: 500,
      });

      // Send prompt request for summary.
      let summary_prompt = `Geef een beknopte omschrijving van de volgende feedback in maximaal 2 zinnen: ${feedback}. Geef dit in HTML.`;
      let summary_result = await API.openAi.prompt({
        prompt: summary_prompt,
        max_tokens: 500,
      });

      // Send prompt for suggestions
      let suggestions_prompt = `Je bent een UX specialist. Geef maximaal 3 suggesties, met ieder een titel van maximaal 5 woorden, hoe een website verbeterd kan worden aan de hand van de volgende feedback van participanten. Geef dit in een array in JSON format. ${feedback}.`;
      let suggestions_result = await API.openAi.prompt({
        prompt: suggestions_prompt,
        max_tokens: 500,
      });
      const suggestions = JSON.parse(suggestions_result);

      // Create insight
      await API.test.createInsight(this.$route.params.id, {
        title: title_result,
        behavior_comment: "...",
        eeg_comment: "",
        explanation: explanation_result,
        eye_tracking_comment: "",
        highlight_id: this.selectedTags[0],
        significant_points_ids: this.selectedTags,
        suggestion: "",
        summary: summary_result,
        touch_tracking_comment: "",
      });

      const res2 = await API.test.getInsights(this.$route.params.id);
      const latest = await res2.data.insights.reduce(function(prev, current) {
        return prev.id > current.id ? prev : current;
      });

      // Add explanation to insight
      for (let x in suggestions) {
        await API.test.createSuggestion({
          author_id: this.$store.state.user.user.id,
          title: suggestions[x].Titel,
          suggestion: suggestions[x].Suggestie,
          test_id: this.$route.params.id,
          insight_id: latest.id,
        });
      }

      this.isLoading = false;
      this.selectedTags = [];
    },
  },
};
